import React from 'react';

export default ({ value, onChangeEvent, onValidate=()=>{} }) => {

  return (
    <div className='Voucher'>
      <div className="form">

        <input
          id='promo'
          type='text'
          value={value}
          name='voucher'
          onChange={onChangeEvent}
          placeholder='Gift Voucher or Discount Code'
        />

        <button onClick={onValidate}>APPLY</button>

      </div>
    </div>
  )
}
